/** Minimal survey-ui-config types for CLI seed resolution (mirrors survey-wizard schema). */

export const QUESTION_TYPE_LITERALS = [
  'MCQ',
  'TEXTFIELD',
  'NPS_SCALE',
  'CFM_MATRIX',
  'CSAT_MATRIX',
  'RATING_MATRIX',
  'SLIDER_MATRIX',
  'FILE_UPLOAD',
  'TEXT_AND_MEDIA',
  'HEATMAP',
  'RANK_ORDER',
] as const;

export type QuestionTypeLiteral = (typeof QUESTION_TYPE_LITERALS)[number];

export interface LogoConfig {
  fileName: string | null;
  url?: string | null;
}

export interface SurveyUiConfig {
  version: string;
  configuredAt?: string;
  instanceId?: string;
  surveyTypes: QuestionTypeLiteral[];
  global: Record<string, unknown> & { logo?: LogoConfig };
  questionTypes: Record<string, Record<string, unknown>>;
  placeholders: Record<string, string>;
  customFields?: Record<string, string>;
  debug?: { enabled: boolean; sampleAnswers?: Record<string, unknown> };
  partialSave?: { enabled: boolean; debounceMs?: number };
  deploy: { target: 'aws' | 'vercel'; autoDeploy: boolean };
}

export type SurveyUiConfigPartial = Partial<SurveyUiConfig> & {
  global?: Record<string, unknown>;
  questionTypes?: Record<string, Record<string, unknown>>;
};
